import { AfterViewInit, Directive, ElementRef, EventEmitter, NgZone, OnDestroy, Output } from '@angular/core';

@Directive({
    selector: '[observeSidebar]'
})
export class ObserveSidebarDirective implements AfterViewInit, OnDestroy {

    @Output() widthChanged = new EventEmitter<number>();

    private resizeObserver!: ResizeObserver;

    constructor(private el: ElementRef, private ngZone: NgZone) { }

    ngAfterViewInit() {
        this.ngZone.runOutsideAngular(() => {
            this.resizeObserver = new ResizeObserver(entries => {
                const width = entries[0].contentRect.width;
                this.ngZone.run(() => this.widthChanged.emit(width));
            });
            this.resizeObserver.observe(this.el.nativeElement);
        });
    }

    ngOnDestroy(): void {
        this.resizeObserver.disconnect();
    }
}
